// extracted by mini-css-extract-plugin
export default {"alertIcon":"AlertIcon-m_alertIcon-It3cw5SO"};